"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_separator_1 = __importDefault(require("@doordash/component-separator"));
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var lodash_1 = require("lodash");
var Row_1 = __importDefault(require("./Row"));
var styles_1 = require("./styles");
var Section = function (_a) {
    var entry = _a.entry, formState = _a.formState, errors = _a.errors, customStyles = _a.customStyles, _b = _a.isTopLevel, isTopLevel = _b === void 0 ? true : _b;
    var headerTextStyles = isTopLevel ? design_language_1.Text.Styles.Bold24 : design_language_1.Text.Styles.Bold18;
    var CustomSectionRowWrapper = customStyles || styles_1.DefaultSectionWrapper;
    return (React.createElement(CustomSectionRowWrapper, null,
        React.createElement(design_language_1.StackChildren, { size: design_language_1.StackChildren.Sizes.Medium, id: "section_" + lodash_1.snakeCase(entry.name) },
            entry.name && React.createElement(design_language_1.Text, { styles: headerTextStyles }, entry.name),
            entry.rows &&
                entry.rows.map(function (row, idx) { return (React.createElement(Row_1["default"], { key: "section__row__" + idx, width: entry.width, entry: row, formState: formState, errors: errors })); }),
            entry.sections &&
                entry.sections.map(function (subSection, idx) { return (React.createElement(Section, { key: "section__section__" + idx, entry: subSection, formState: formState, errors: errors, customStyles: customStyles, isTopLevel: false })); }),
            isTopLevel && (React.createElement(component_separator_1["default"], { type: component_separator_1["default"].Types.InsetBorder, inset: design_language_1.Spacing.None })))));
};
exports["default"] = Section;
